


















































import { defineComponent, ref } from '@vue/composition-api';

const name = 'ttam-material-upload-select-table-name-change-change';

export default defineComponent({
  name,

  props: {
    name: { type: String, default: '' },
    error: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const curName = ref('');

    function onChange(val) {
      curName.value = val;
    }

    function onCancel() {
      emit('cancel');
    }

    function onConfirm() {
      emit('confirm', curName.value);
    }

    return {
      curName,
      onChange,
      onCancel,
      onConfirm,
    };
  },
});
